import { ACCORDION_UPDATE_SELECTION } from '../action-types';

const updateAccordionWithId =
  // @ts-expect-error - Automatic, Please fix when editing this file


    ({ id, openIndices }) =>
    // @ts-expect-error - Automatic, Please fix when editing this file
    (dispatch) => {
      dispatch({ payload: { id, openIndices }, type: ACCORDION_UPDATE_SELECTION });
    };

export default {
  updateAccordionWithId,
};
